import {Inject, Injectable, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {SentryConfig} from '../../domain/monitoring/sentryConfig';
import {IziviaDeviceService} from '../common/iziviaDevice.service';
import {tap} from 'rxjs/operators';
import {IziviaLoggerService} from '../common/iziviaLogger.service';
import {IziviaErrorReportingService} from './iziviaErrorReporting.service';
import {HOST_THIRD_PARTY_ID} from '../../tokens/thirdParty.token';
import {IziviaErrorReportingOptions} from '../../domain/utils/errorReporting/iziviaErrorReportingOptions';

@Injectable({
    providedIn: 'root'
})
export class IziviaSentryService implements OnDestroy {

    private connectedUserSubscription: Subscription;

    constructor(private readonly loggerService: IziviaLoggerService,
        private readonly errorReportingService: IziviaErrorReportingService,
        private readonly deviceService: IziviaDeviceService,
        @Inject(HOST_THIRD_PARTY_ID) private thirdPartyId: string) {
    }

    public startSentry(apiVersion: string, sentryConfig: SentryConfig): boolean {
        if (!sentryConfig.sentryToken || !sentryConfig.sentryProject) {
            this.loggerService.warning('ErrorReportingService failed starting, missing token or project',
                sentryConfig.sentryToken, sentryConfig.sentryProject);
            return false;
        }

        const errorReportingOptions: IziviaErrorReportingOptions = {
            version: apiVersion,
            thirdPartyId: this.thirdPartyId,
            token: sentryConfig.sentryToken,
            project: sentryConfig.sentryProject,
            environment: sentryConfig.sentryEnvironment
        };
        this.errorReportingService.startReporting(errorReportingOptions);

        this.attachSentryDeviceIdTag();

        return true;
    }

    private attachSentryDeviceIdTag(): void {
        this.deviceService.deviceId$
            .pipe(
                tap(deviceId => this.loggerService.debug(`Sentry -> Attach device id ${deviceId} to tags`))
            )
            .subscribe(deviceId => this.errorReportingService.setDevice(deviceId));
    }

    ngOnDestroy(): void {
        this.connectedUserSubscription?.unsubscribe();
    }
}
